import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { GiftCardPurchaseRoutingModule } from './gift-card-purchase-routing.module';
import { GiftCardPurchaseComponent } from './gift-card-purchase.component';
import { SenderInformationComponent } from './sender-information/sender-information.component';
import { MessageComponent } from './message/message.component';
import { RecipientOptionComponent } from './recipient-option/recipient-option.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { GiftCardPurchaseFormService } from './gift-card-purchase-form/gift-card-purchase-form.service';
import { ReactiveFormsModule } from '@angular/forms';
import { DesignAndAmountModule } from './design-and-amount/design-and-amount.module';
import { QaModule } from '@daysmart/angular-qa-module';

@NgModule({
    declarations: [
        GiftCardPurchaseComponent,
        SenderInformationComponent,
        MessageComponent,
        RecipientOptionComponent,
    ],
    imports: [
        CommonModule,
        GiftCardPurchaseRoutingModule,
        MatButtonModule,
        MatTabsModule,
        MatInputModule,
        MatCardModule,
        ReactiveFormsModule,
        DesignAndAmountModule,
        QaModule,
    ],
    providers: [GiftCardPurchaseFormService],
})
export class GiftCardPurchaseModule {}
